import React, {
  forwardRef, memo,
} from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import Header from './headerResults';
import Row from './rowResults';
import { useReportResult } from './hooks';

const StyleTable = styled.table`
  border-collapse: collapse;
  table-layout: fixed;
  width: 100%;

  td, th {
    border: 1px solid var(--falcon-gray-300);
    padding: .25rem .5rem;
  }

  th {
    position: sticky;
    top: 0;
    z-index: 3;
    background-color: var(--falcon-white);
  }
;

  tfoot td {
    font-weight: 600;
  }

  @media print {
    position: relative;
    //width: 80%;
    //display: block;
    //color: red;
  }

  ${({ addStyles }) => addStyles}

`;

const Results = forwardRef(({
  result, caption, onContextMenu, isPortrait,
}, ref) => {
  const {
    header, body, footer,
    groupRows, rowLevels, closedRowGroups, onToggleRowGroup, invisibleRows, onRowLevelToggle,
    gridTemplate,
  } = useReportResult({ result, isPortrait });
  return (
    <div id="capture" className="w-100">
      <div id="print-area-rep" ref={ref} className="w-100">
        {caption && (
          <h3>{caption}</h3>
        )}
        <StyleTable
          addStyles={Object.keys(result.styles).map((s) => `.${s}  { ${result.styles[s]}}`)}
        >
          <Header
            lines={header}
            rowLevels={rowLevels}
            onRowLevelToggle={onRowLevelToggle}
            gridTemplate={gridTemplate}
          />
          <tfoot>
            {footer.map((row) => (
              <tr key={row[0].row_num}>
                {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                <td className="d-print-none">&nbsp;</td>
                {row.map((cell) => (
                  <td
                    key={`row-${cell.row_num} col-${cell.col_num}`}
                    colSpan={cell.colspan}
                    rowSpan={cell.rowspan}
                    className={`FooterOfTable ${cell.className || ''} ${cell.key} ${cell.styles ? cell.styles.join(' ') : ''} `}
                  >
                    {cell.repr}
                  </td>

                ))}
              </tr>
            ))}
          </tfoot>
          <tbody>
            {body.map((cells) => (
              <Row
                key={cells[0].row_num}
                cells={cells}
                visible={!invisibleRows.includes(cells[0].row_num)}
                expanded={!closedRowGroups.includes(cells[0].row_num)}
                onExpandedToggle={onToggleRowGroup}
                onContextMenu={onContextMenu}
                isGroup={!!groupRows[cells[0].row_num]}
              />
            ))}

          </tbody>
        </StyleTable>
      </div>
    </div>
  );
});

Results.propTypes = {
  result: PropTypes.shape({
    meta: PropTypes.shape(),
    data: PropTypes.shape(),
    styles: PropTypes.shape(),
  }),
  caption: PropTypes.string,
  onContextMenu: PropTypes.func,
  isPortrait: PropTypes.bool.isRequired,
};

Results.defaultProps = {
  result: null,
  caption: null,
  onContextMenu: () => null,
};

export default memo(Results);
